import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }


export default /*@__PURE__*/_defineComponent({
  __name: 'FileTree',
  props: {
    nodes: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_FileTree = _resolveComponent("FileTree", true)!

  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.nodes, (node) => {
      return (_openBlock(), _createElementBlock("li", {
        key: node.path
      }, [
        (node.type === 'folder')
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, " 📁 " + _toDisplayString(node.name), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, " 📄 " + _toDisplayString(node.name), 1)),
        (node.children && node.children.length)
          ? (_openBlock(), _createBlock(_component_FileTree, {
              key: 2,
              nodes: node.children
            }, null, 8, ["nodes"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})